<div class="wrapper__headerComponent container mt-3 mt-md-5">
    <div class="row">
        <div class="d-flex flex-row align-items-center align-items-md-start">
            <img src="../../../../assets/img/file-alt.svg" alt="logo" class="img-ico-form" />
            <h2 class="mb-0">{{"crear-empresa.titulo"| translate}}</h2>
        </div>
    </div>
</div>
<div class="container wrapper__headerComponent d-flex flex-column gap-2">
    <div class="border__form rounded px-3 py-4">
        <app-form
            *ngIf="formFieldsEmpresa?.length"
            [fields]="formFieldsEmpresa"
            [title]="''"
            [withSubmitButton]="false"
            (changeAction)="validarFormulario($event)"
            (changedControl)="onChangeValidarFormulario($event)"
            [idEntidad]="entidadId" />
        <div class="mt-3">
            <div class="card-body form-group">
                <app-cargue-archivos-tramite
                    *ngIf="mostrarComponenteCarga"
                    [isRegistryEmpresa]="true"
                    [archivosPreCargados]="archivosPrecargado"
                    [btnEnviar]="false"
                    [enviar]="enviarDocumentos"
                    [enviarEntidad]="enviarEntidad"
                    (archivosValidados)="getFlagFileValidos($event)"
                    (guardo)="subirArchivo($event)"
                    (archivosCargados)="
                      validarArchivosCargados($event)
                    "></app-cargue-archivos-tramite>
            </div>
        </div>
        <div class="col-12 col-md-12 py-3 d-flex justify-content-end">
            <div class="d-flex flex-column flex-md-row gap-2">
                <button type="button"
                    class="btn-govco fill-btn-govco w-auto"
                    (click)="finalizar()"
                    aria-label="Finalizar">
                    {{ 'tramites.botones-envio.enviar'| translate }}
                </button>
            </div>
        </div>
    </div>
  <!-- Se comenta el correo, de acuerdo con el bug # 5765-->
<!--    <div class="mt-4 text-muted small text-center">-->
<!--        <i class="bi bi-envelope"></i> {{ 'autenticacion-digital.correoAyuda' | translate }}-->
<!--    </div>-->
</div>
